module.exports = __webpack_public_path__ + "static/media/Seamus Finnigan 2.521f7eff.jpg";